export default "__VITE_ASSET__BUOG1JV___"